/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GetClientsApiArg, GetClientsApiResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClients: build.query<GetClientsApiResponse, GetClientsApiArg>({
      query: (queryArg) => ({
        method: 'GET',
        params: {
          limit: queryArg.limit,
          page: queryArg.page,
          search: queryArg.search,
          sortBy: queryArg.sortBy,
        },
        url: `/v1/clients`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getClientsApi };
export const { useGetClientsQuery, useLazyGetClientsQuery } = injectedRtkApi;
